import { ApiError } from "@/types/workSessions.type";
import { api } from "./api";
import axios from "axios";
import { EmployeesResponse } from "@/types/user.types";

export const getEmployees = async (): Promise<EmployeesResponse> => {
  try {
    const response = await api.get("/users/pointeuse/employees");
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const apiError = error.response?.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Erreur lors de la récupération des employés"
      );
    }
    throw new Error("Erreur lors de la récupération des employés");
  }
};
